import { localizedPath, type CaseStudy, type Language } from './caseStudyData';
import { startupSeo } from './startupSeo';
import { marketingPages, marketingPath, type FounderGuide, type MarketingPageSlug } from './marketingPagesData';
import { copy } from './marketingContent';

export function homeSeo(language: Language) {
  const base = startupSeo(language);
  const origin = new URL(base.canonical).origin;
  const canonical = origin + (language === 'ar' ? '/ar/' : '/');
  const title = copy[language].title;
  const description = copy[language].subtitle;
  return { ...base, title, description, canonical, alternates: { en: origin + '/', ar: origin + '/ar/' }, structuredData: {
    '@context': 'https://schema.org', '@graph': [
      { '@type': 'WebPage', '@id': canonical, url: canonical, name: title, description, inLanguage: language },
      { '@type': 'BreadcrumbList', itemListElement: [{ '@type': 'ListItem', position: 1, name: language === 'ar' ? 'الرئيسية' : 'Home', item: canonical }] },
    ],
  } };
}

export function marketingSeo(language: Language, slug: MarketingPageSlug, guide?: FounderGuide) {
  const base = startupSeo(language);
  const path = guide ? `guides/${guide.slug}` : slug;
  const [, headline, intro] = marketingPages[slug][language];
  const title = `${guide?.[language].title ?? headline} | Heglo`;
  const description = guide?.[language].summary ?? intro;
  const origin = new URL(base.canonical).origin;
  const canonical = origin + marketingPath(language, path);
  return { ...base, title, description, canonical, alternates: { en: origin + marketingPath('en', path), ar: origin + marketingPath('ar', path) }, structuredData: { '@context': 'https://schema.org', '@graph': [
    { '@type': 'WebPage', '@id': canonical, url: canonical, name: title, description, inLanguage: language },
    { '@type': 'BreadcrumbList', itemListElement: [ { '@type': 'ListItem', position: 1, name: marketingPages[slug][language][0], item: origin + marketingPath(language, slug) }, ...(guide ? [{ '@type': 'ListItem', position: 2, name: guide[language].title, item: canonical }] : []) ] },
  ] } };
}

export function caseStudySeo(language: Language, study: CaseStudy) {
  const base = startupSeo(language);
  const origin = new URL(base.canonical).origin;
  const path = `/case-studies/${study.slug}`;
  const canonical = origin + localizedPath(path, language);
  const title = `${study.copy[language].name} | ${language === 'ar' ? 'دراسات الحالة' : 'Case studies'} | Heglo`;
  const description = study.copy[language].summary;
  return { ...base, title, description, canonical,
    alternates: { en: origin + localizedPath(path, 'en'), ar: origin + localizedPath(path, 'ar') },
    structuredData: { '@context': 'https://schema.org', '@graph': [
      { '@type': 'WebPage', '@id': canonical, url: canonical, name: title, description, inLanguage: language },
    ] },
  };
}
